import { forwardRef, Children, cloneElement } from 'react';
import { getStepperNavStyles, getStepperStyles } from './StepperStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { StepStatus } from '../Step/types/status.js';

const Stepper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    currentStep,
    children,
    ...rest
  } = _ref;
  const getStatus = index => {
    if (index === currentStep) {
      return StepStatus.STATUS_CURRENT;
    } else if (currentStep && index < currentStep) {
      return StepStatus.STATUS_COMPLETED;
    }
    return StepStatus.STATUS_DISABLED;
  };
  return jsx("nav", {
    css: getStepperNavStyles,
    ref: ref,
    ...rest,
    children: jsx("div", {
      css: getStepperStyles,
      children: Children.toArray(children).filter(step => !!step).map((step, index) => /*#__PURE__*/cloneElement(step, {
        status: getStatus(index + 1),
        isLastStep: Children.toArray(children).length === index + 1
      }))
    })
  });
});
Stepper.displayName = 'Stepper';

export { Stepper };
//# sourceMappingURL=Stepper.js.map
